import { type SvgIconProps } from '@mui/material';
import React from 'react';

function ProfileBannerIcon(props: SvgIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="23"
      height="20"
      fill="none"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 1C0 0.447715 0.447715 0 1 0H11C11.5523 0 12 0.447716 12 1V15.7497L6 12.3047L0 15.75V1ZM7.75 4.74079C7.75 5.7022 6.9665 6.48158 6 6.48158C5.0335 6.48158 4.25 5.7022 4.25 4.74079C4.25 3.77938 5.0335 3 6 3C6.9665 3 7.75 3.77938 7.75 4.74079ZM8.12 7.98789C7.53503 7.69798 6.81494 7.47632 6 7.47632C5.18506 7.47632 4.46497 7.69798 3.88 7.9936C3.33997 8.26074 3 8.87462 3 9.54538V9.75H9V9.53968C9 8.87462 8.66003 8.26074 8.12 7.98789Z"
        fill="#232729"
      />
    </svg>
  );
}

export default ProfileBannerIcon;
